export const FEATURE_NAME = '@zerops/zerops/core/resource-consumption-base';

// Reuse exact same time grouping and ranges from transaction-debit  
export {
  TRANSACTION_GROUP_RANGE,
  TransactionGroupBy as ResourceConsumptionGroupBy,
  TransactionTimeGroupBy as ResourceConsumptionTimeGroupBy,
  getTransactionGroupRangeKey as getResourceConsumptionGroupRangeKey
} from '@zerops/models/transaction-debit';